module.exports = __webpack_public_path__ + "img/9_lg.d48ba09b.jpg";